module.exports = __webpack_public_path__ + "static/media/inetcpl_1309.5277fafe.ico";